import { render, staticRenderFns } from "./ManualTask.vue?vue&type=template&id=61d667ab&scoped=true&"
import script from "./ManualTask.vue?vue&type=script&lang=js&"
export * from "./ManualTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d667ab",
  null
  
)

export default component.exports